import React, { Component } from 'react';
import PinInput from 'react-pin-input';
import Modal from 'react-bootstrap/Modal';
import iconSprite from '../../../assets/icon-sprite.svg';

class PIN extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pin: '',
    };
  }

  handleOnChange = (pin) => {
    this.setState({ pin });
  };

  handleOnSubmit = async (e) => {
    e.preventDefault();
    const { onClose, onSubmit } = this.props;
    const { pin } = this.state;
    onClose?.();
    onSubmit?.(pin);
  }

  render() {
    const { body, visible, onClose = function $() { } } = this.props;
    const { pin } = this.state;
    return (
      <Modal className="modal fade" centered show={visible} onHide={onClose}>
        <form
          className="modal-form"
          onSubmit={this.handleOnSubmit}>
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="deleteCustomerLabel">Enter 4 Digit PIN:</h5>
              <button type="button" className="close" onClick={onClose}>
                <svg width="48" height="48">
                  <use xlinkHref={iconSprite + '#close-icon'}></use>
                </svg>
              </button>
            </div>
            <div className="modal-body">
              <div className="modal-body_message d-flex text-center justify-content-center align-items-center flex-column">
                {body}
                <div className="form-group">
                  <label htmlFor="pin" className="form-label">Enter your 4 Digit PIN to authorise this transaction:</label>
                  <PinInput
                    length={4}
                    focus={false}
                    secret
                    type="numeric"
                    inputStyle={{ borderColor: '#00AEEF' }}
                    onChange={this.handleOnChange} />
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="submit"
                disabled={pin.length !== 4}
                className="btn btn-primary">
                Proceed
              </button>
            </div>
          </div>
        </form>
      </Modal>
    );
  }
}

export default PIN;
